/**
 * Minimal ABI for Circle CCTP v2 MessageTransmitterV2 contract.
 *
 * Only includes the functions needed for completing a cross-chain transfer:
 * - receiveMessage: finalises a burn on the destination chain, minting USDC to the recipient
 *
 * Full ABI: https://developers.circle.com/stablecoins/cctp-protocol-contract
 */
export const MessageTransmitterV2Abi = [
  {
    name: 'receiveMessage',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'message', type: 'bytes' },
      { name: 'attestation', type: 'bytes' },
    ],
    outputs: [{ name: 'success', type: 'bool' }],
  },
] as const;
